var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        _vm._l(_vm.array, function (e, i) {
          return _c(
            "v-col",
            { key: i, staticClass: "soli-round", attrs: { cols: _vm.cols } },
            [
              _c("v-skeleton-loader", {
                staticClass: "soli-round",
                attrs: { type: _vm.type },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }